











import PageTemplate from "@/components/PageTemplate.vue";
import { RouteName } from "@/router/types";
import { Vue, Component } from "vue-property-decorator";
import PinsList from "@/components/Pins/PinsList.vue";
import PinsForm from "@/components/Pins/PinsForm.vue";

@Component({
  components: {
    PageTemplate,
    PinsList,
    PinsForm,
  },
})
export default class Pins extends Vue {
  RouteName = RouteName;
}
